<template>
  <Transition :name="name" :mode="mode">
    <slot />
  </Transition>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    name?: 'fade' | 'slide';
    mode?: 'in-out' | 'out-in';
  }>(),
  {
    name: 'fade',
    mode: 'out-in'
  }
);
</script>

<style lang="postcss">
.fade-enter-active,
.fade-leave-active {
  @apply transition-opacity duration-300;
}

.fade-enter-from,
.fade-leave-to {
  @apply opacity-0;
}

.slide-enter-active,
.slide-leave-active {
  @apply transition-transform duration-300;
}

.slide-enter-from,
.slide-leave-to {
  @apply translate-y-4;
}
</style>
